
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ReservedQrCodeDto_$reflection, LabelInventoryKind_$reflection, LabelPreviewData_$reflection, LabelPrintItem_$reflection } from "../../../Shared/Label.js";
import { class_type, string_type, unit_type, record_type, list_type, bool_type, option_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, LabelTextLine_$reflection, FormState_$reflection, LabelConfiguration_$reflection, RequestedValue$1_$reflection, CustomerConfiguration_$reflection } from "../../../Shared/Shared.js";

export class PreviewSource extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SampleData", "InventoryData"];
    }
}

export function PreviewSource_$reflection() {
    return union_type("Settings.Labels.Types.PreviewSource", [], PreviewSource, () => [[], [["Item1", LabelPrintItem_$reflection()], ["Item2", LabelPreviewData_$reflection()]]]);
}

export class State extends Record {
    constructor(CustomerConfiguration, Draft, IsDirty, ActiveKind, PreviewSource, ReservedCodes, FormState) {
        super();
        this.CustomerConfiguration = CustomerConfiguration;
        this.Draft = Draft;
        this.IsDirty = IsDirty;
        this.ActiveKind = ActiveKind;
        this.PreviewSource = PreviewSource;
        this.ReservedCodes = ReservedCodes;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Labels.Types.State", [], State, () => [["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["Draft", option_type(LabelConfiguration_$reflection())], ["IsDirty", bool_type], ["ActiveKind", LabelInventoryKind_$reflection()], ["PreviewSource", PreviewSource_$reflection()], ["ReservedCodes", RequestedValue$1_$reflection(list_type(ReservedQrCodeDto_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomerConfigurationFetched", "CreateDraft", "DiscardDraft", "SetDraft", "SetActiveKind", "SetTextLines", "Save", "Saved", "SetEnabled", "EnabledSaved", "PreviewInventory", "PreviewFetched", "ResetPreview", "TestPrint", "TestPrinted", "ReservedCodesFetched", "DeleteReservedCode", "ReservedCodeDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Labels.Types.Msg", [], Msg, () => [[["Item", CustomerConfiguration_$reflection()]], [], [], [["Item", LabelConfiguration_$reflection()]], [["Item", LabelInventoryKind_$reflection()]], [["Item1", LabelInventoryKind_$reflection()], ["Item2", list_type(LabelTextLine_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(CustomerConfiguration_$reflection())]], [["Item", bool_type]], [["Item", ClientApiResponse$1_$reflection(CustomerConfiguration_$reflection())]], [["Item", LabelPrintItem_$reflection()]], [["Item1", LabelPrintItem_$reflection()], ["Item2", ClientApiResponse$1_$reflection(LabelPreviewData_$reflection())]], [], [], [["Item", unit_type]], [["Item", list_type(ReservedQrCodeDto_$reflection())]], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(unit_type)]], [["Item", class_type("System.Exception")]]]);
}

